<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>服務機關</td>
                  <td colspan="3">
                    <select
                      v-model="form.jobGovCode1"
                      style="min-width: 200px"
                      @change="JobGovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode2"
                      style="min-width: 200px"
                      @change="JobGovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum &&
                        loginInfo.govCode != '355010000I' &&
                        loginInfo.govCode != 'A11100000F'
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode3"
                      style="min-width: 200px"
                      @change="JobGovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum &&
                        loginInfo.govCode != '355010000I' &&
                        loginInfo.govCode != 'A11100000F'
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum &&
                        loginInfo.govCode != '355010000I' &&
                        loginInfo.govCode != 'A11100000F'
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.jobGovCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關：</td>
                  <td colspan="3">
                    <select
                      v-model="form.govCode1"
                      style="min-width: 200px"
                      @change="GovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode2"
                      style="min-width: 200px"
                      @change="GovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode3"
                      style="min-width: 200px"
                      @change="GovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.govCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>身分證統一編號：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.idn" />
                  </td>
                  <td>姓名：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="
                            () => {
                              this.form.currentpage = 1;
                              this.form.pagesize = 10;
                              this.doQuery();
                            }
                          "
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%" v-if="grid && grid.gridDatas">
            <tbody>
              <tr>
                <td v-if="grid.paginaiton" align="right">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    maxlength="4"
                    size="2"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    maxlength="4"
                    size="2"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th>操作</th>
                    <th style="min-width: 80px">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('NAME', Sort);
                          }
                        "
                        >姓名</u
                      >
                    </th>
                    <!-- <th>身分證號</th> -->
                    <th style="min-width: 100px">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('JOB_GOV_CODE', Sort);
                          }
                        "
                        >服務機關</u
                      >
                    </th>
                    <th style="min-width: 100px">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('GOV_CODE', Sort);
                          }
                        "
                        >受理申報機關</u
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="上傳"
                        @click="btnUpload(data)"
                      />
                    </td>
                    <td>{{ data.name }}</td>
                    <!-- <td>{{ data.idn }}</td> -->
                    <td>{{ data.joB_GOV_CODE_NAME }}</td>
                    <td>{{ data.goV_CODE_NAME }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <PdisFooter />

    <UploadModal
      v-model="UploadModal.show"
      :title="UploadModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <table width="100%">
          <tbody>
            <tr>
              <td>
                <input
                  type="button"
                  class="btn"
                  value="新增紙本上傳"
                  @click="UploadModalBtnAdd()"
                />
              </td>
              <td v-if="UploadModal.grid.paginaiton" align="right">
                <input
                  type="button"
                  value="<<"
                  class="btn"
                  style="height: 28px"
                  @click="
                    UploadModal.form.currentpage =
                      UploadModal.grid.paginaiton.pageNo - 1
                  "
                  v-show="UploadModal.grid.paginaiton.pageNo > 1"
                />
                <span
                  v-for="(data, index) in UploadModal.grid.paginaiton.pages"
                  :key="index"
                  style="cursor: pointer"
                  :style="
                    UploadModal.grid.paginaiton.pageNo == data
                      ? 'color:red'
                      : 'color:black'
                  "
                  @click="UploadModal.form.currentpage = parseInt(data)"
                >
                  {{
                    UploadModal.grid.paginaiton.pageNo == data
                      ? "[" + data + "]"
                      : data
                  }}
                </span>
                <input
                  type="button"
                  class="btn"
                  value=">>"
                  style="height: 28px"
                  v-show="
                    UploadModal.grid.paginaiton.pageNo <
                    UploadModal.grid.paginaiton.totalPage
                  "
                  @click="
                    UploadModal.form.currentpage =
                      UploadModal.grid.paginaiton.pageNo + 1
                  "
                />
                ［每頁<input
                  type="text"
                  v-model.number.lazy="UploadModal.form.pagesize"
                  size="2"
                  maxlength="4"
                />

                <input type="button" class="btn" value="筆" />，第<input
                  type="text"
                  v-model.number.lazy="UploadModal.form.currentpage"
                  size="2"
                  maxlength="4"
                />
                <input type="button" class="btn" value="頁" />，共
                {{ UploadModal.grid.paginaiton.totalPage }} 頁
                {{ UploadModal.grid.paginaiton.totalCount }} 筆］
              </td>
            </tr>
          </tbody>
        </table>
        <div class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>操作</th>
                  <th>姓名</th>
                  <!-- <th>身分證號</th> -->
                  <th>受理申報單位</th>
                  <th>申報日期</th>
                  <th>上傳時間</th>
                  <th>最後維護時間</th>
                </tr>
              </thead>
              <tbody
                v-if="
                  UploadModal.grid &&
                  UploadModal.grid.gridMainDatas &&
                  UploadModal.grid.gridMainDatas.length > 0
                "
              >
                <tr
                  v-for="(data, index) in UploadModal.grid.gridMainDatas"
                  :key="index"
                >
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="編"
                      @click="UploadModalBtnEdit(data, index)"
                    />
                  </td>
                  <td>{{ data.name }}</td>
                  <!-- <td>{{ data.idn }}</td> -->
                  <td>{{ data.goV_CODE_NAME }}</td>
                  <td>{{ data.sdate }}</td>
                  <td>
                    {{
                      padLeft(
                        parseInt($moment(data.datetime).format("YYYY")) - 1911
                      ) + $moment(data.datetime).format("MMDD")
                    }}
                  </td>
                  <td>{{ data.oP_DATE_STR }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果結束-->
      </div>
    </UploadModal>

    <UploadDetailModal
      v-model="UploadDetailModal.show"
      :title="UploadDetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>受理申報機關</td>
                <td colspan="3">
                  <select
                    v-model="UploadDetailModal.form.jobGovCode1"
                    style="min-width: 200px"
                    @change="UploadDetailModalJobGovCode1Change()"
                    disabled
                  >
                    <option
                      v-for="(item, index) in UploadDetailModal.dropDownList
                        .jobGovCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="UploadDetailModal.form.jobGovCode2"
                    style="min-width: 200px"
                    @change="UploadDetailModalJobGovCode2Change()"
                    disabled
                  >
                    <option
                      v-for="(item, index) in UploadDetailModal.dropDownList
                        .jobGovCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="UploadDetailModal.form.jobGovCode3"
                    style="min-width: 200px"
                    @change="UploadDetailModalJobGovCode3Change()"
                    disabled
                  >
                    <option
                      v-for="(item, index) in UploadDetailModal.dropDownList
                        .jobGovCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="UploadDetailModal.form.jobGovCode4"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in UploadDetailModal.dropDownList
                        .jobGovCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>身分證統一編號/居留證號</td>
                <td>
                  <input
                    type="text"
                    v-model="UploadDetailModal.form.idn"
                    disabled
                  />
                </td>
                <td>姓名</td>
                <td>
                  <input
                    type="text"
                    v-model="UploadDetailModal.form.name"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>申報日期</td>
                <td>
                  <DatePicker
                    v-model="UploadDetailModal.form.sdate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                </td>
                <td>申報年度</td>
                <td>
                  <select v-model="UploadDetailModal.form.syear">
                    <option
                      v-for="(data, index) in UploadDetailModal.dropDownList
                        .syears"
                      :key="index"
                      :value="data"
                    >
                      {{ data }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>上傳(即交件日)</td>
                <td>
                  <DatePicker
                    v-model="UploadDetailModal.form.datetime"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                </td>
                <td>申報類別</td>
                <td>
                  <select v-model="UploadDetailModal.form.dtype">
                    <option value=""></option>
                    <option value="1">定期申報</option>
                    <option value="2">就到職申報</option>
                    <option value="3">代理及兼任申報</option>
                    <option value="4">解除代理及解除兼任申報</option>
                    <option value="5">卸（離）職申報</option>
                    <option value="6">不須申報</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>申報資料上傳</td>
                <td>
                  <label for="fileField"></label>
                  <input
                    type="file"
                    accept=".pdf"
                    @change="UploadDetailModalOnFileChange"
                  />
                  <br /><font color="#FF0000">上傳檔案需為5MB以下的PDF檔</font>
                  <br />
                  <a v-if="UploadDetailModal.grid.length > 0" v-on:click="DetailUploadPrint(UploadDetailModal.grid[0])">
                    {{UploadDetailModal.grid[0].filE_NAME }}
                  </a>
                </td>
                <td>是否為更正申報</td>
                <td>
                  <p>
                    <label>
                      <input
                        type="radio"
                        v-model="UploadDetailModal.form.upApplyFlag"
                        value="Y"
                      />
                      是</label
                    >
                    <label>
                      <input
                        type="radio"
                        v-model="UploadDetailModal.form.upApplyFlag"
                        value="N"
                      />
                      否</label
                    >
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  配偶及未成年子女<br />
                  <input
                    type="button"
                    class="btn"
                    value="新增"
                    @click="UploadDetailModalBtnAdd()"
                  />
                </td>
                <td colspan="3">
                  <div class="information">
                    <table width="100%"></table>
                    <div class="active">
                      <div class="table_scroll2">
                        <table width="1060" class="itable">
                          <thead>
                            <tr>
                              <th colspan="2">操作</th>
                              <th>稱謂</th>
                              <th>姓名</th>
                              <th>身分證統一編號/居留證號</th>
                              <th>生日</th>
                            </tr>
                          </thead>
                          <tbody
                            v-if="UploadDetailModal.form.familyDatas.length > 0"
                          >
                            <tr
                              v-for="(data, index) in UploadDetailModal.form
                                .familyDatas"
                              :key="index"
                            >
                              <td width="1%" align="center">
                                <input
                                  type="button"
                                  class="btn"
                                  value="編"
                                  @click="UploadDetailModalBtnEdit(index)"
                                />
                              </td>
                              <td width="1%" align="center">
                                <input
                                  type="button"
                                  class="btn"
                                  value="刪"
                                  @click="UploadDetailModalBtnDelete(index)"
                                />
                              </td>

                              <td style="text-align: center">
                                {{
                                  data.title == "1"
                                    ? "配偶"
                                    : data.title == "2"
                                    ? "子"
                                    : data.title == "3"
                                    ? "女"
                                    : data.title
                                }}
                              </td>
                              <td style="text-align: center">
                                {{ data.name }}
                              </td>
                              <td style="text-align: center">
                                {{ data.idn == "" ? data.passport : data.idn }}
                              </td>
                              <td style="text-align: center">
                                {{
                                  data.birthdate.length == 0
                                    ? ""
                                    : data.birthdate.length == 7
                                    ? data.birthdate
                                    : padLeft(
                                        $moment(data.birthdate).format("YYYY") -
                                          1911
                                      ) + $moment(data.birthdate).format("MMDD")
                                }}
                                <!-- {{ padLeft($moment(data.birthdate).format('YYYY') - 1911)  +  $moment(data.birthdate).format('MMDD') }} -->
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td
                                colspan="6"
                                style="text-align: center; display: table-cell"
                              >
                                查無資料
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="存檔"
                        @click="UploadDetailModalBtnSave()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="UploadDetailModalBtnClear()"
                        :disabled="UploadDetailModal.modifyType == 'U'"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </UploadDetailModal>

    <FamilyModal
      v-model="FamilyModal.show"
      :title="FamilyModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>稱謂</td>
                <td>
                  <p>
                    <select
                      name="select"
                      id="select"
                      v-model="FamilyModal.form.title"
                    >
                      <option value="1">配偶</option>
                      <option value="2">子</option>
                      <option value="3">女</option>
                    </select>
                  </p>
                </td>
              </tr>
              <tr>
                <td>姓名</td>
                <td><input type="text" v-model="FamilyModal.form.name" /></td>
              </tr>
              <tr>
                <td>出生年月日</td>
                <td>
                  <DatePicker
                    v-model="FamilyModal.form.birthdate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                  /><br />
                </td>
              </tr>
              <tr>
                <td>身分證統一編號</td>
                <td>
                  <input
                    type="text"
                    class="input"
                    v-model="FamilyModal.form.idn"
                    size="10"
                    maxlength="10"
                  />
                </td>
              </tr>
              <tr>
                <td>居留證號</td>
                <td>
                  <input
                    type="text"
                    class="input"
                    v-model="FamilyModal.form.passport"
                    size="40"
                    maxlength="40"
                  />
                </td>
              </tr>
              <tr>
                <td colspan="4" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        @click="FamilyModalBtnSave()"
                        value="存檔"
                      />
                      <input
                        type="submit"
                        class="btn"
                        @click="FamilyModalBtnClear()"
                        value="重填"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </FamilyModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenu, logOut } from "@/config/util.js";
import {
  ChkIDorRCNumber,
  ChkIdNo,
  isLiveID,
  getMenuIndex,
} from "@/config/util.js";
import {
  UploadReportOld,
  SearchGovCode,
  B102_SearchGrid,
  B102_ReSearchGrid,
  B102_SearchGridMain,
  B102_DetailAdd,
  B102_DetailAddSave,
  B102_DetailEditSave,
  B102_DetailFamily,
  B101_UploadReport
} from "@/service/api.js";

export default {
  name: "B102",
  data: function () {
    return {
      pageData: {
        MenuIndex: 2,
        MenuName: "",
        PrgName: "B102",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      Order: "",
      Sort: "",
      form: {
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "1",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        idn: "",
        name: "",
        currentpage: 1,
        pagesize: 10,
      },
      dropDownList: {
        govCode1s: [],
        govCode2s: [],
        govCode3s: [],
        govCode4s: [],
        jobGovCode1s: [],
        jobGovCode2s: [],
        jobGovCode3s: [],
        jobGovCode4s: [],
      },
      grid: {},
      UploadModal: {
        show: false,
        title: "-紙本上傳",
        form: {
          currentpage: 1,
          pagesize: 10,
        },
        PreData: {},
        grid: {},
      },
      UploadDetailModal: {
        show: false,
        title: "-新增",
        modifyType: "I", //I,U
        form: {
          pkno: 0,
          jobGovCode1: sessionStorage.getItem("Session_GovCode"),
          jobGovCode2: "",
          jobGovCode3: "",
          jobGovCode4: "",
          idn: "",
          name: "",
          sdate: "",
          syear: "",
          datetime: "",
          dtype: "",
          upApplyFlag: "N",
          familyDatas: [],
          file: {
            fileName: "",
            fileType: "",
            fileString: [],
          },
          uploadFile: "",
        },
        dropDownList: {
          jobGovCode1s: [],
          jobGovCode2s: [],
          jobGovCode3s: [],
          jobGovCode4s: [],
          syears: [],
        },
        PreData: {},
        grid: {},
      },
      FamilyModal: {
        show: false,
        title: "-配偶及未成年子女",
        modifyType: "I", //I,U
        index: 0,
        form: {
          title: "2", //預設子
          name: "",
          birthdate: "",
          idn: "",
          passport: "",
        },
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    UploadModal: VueModal,
    UploadDetailModal: VueModal,
    FamilyModal: VueModal,
    Alert: VueModal,
    DatePicker: VueDatepicker,
  },
  methods: {
    //日期補0
    padLeft: function (str) {
      str = typeof str !== "string" ? "" + str : str;
      return str.length >= 3 ? str : this.padLeft("0" + str);
    },
    //取得服務機關第一層類別
    getSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode1s = rData.returnObject;
      });
    },
    //取得服務機關第二層類別
    getSearchGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode2s = rData.returnObject;
      });
    },
    //取得服務機關第三層類別
    getSearchGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode3s = rData.returnObject;
      });
    },
    //取得服務機關第四層類別
    getSearchGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode4s = rData.returnObject;
      });
    },
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        if (self.loginInfo.govCode == "355010000I") {
          self.dropDownList.jobGovCode2s = rData.returnObject.filter(
            (x) => x.value == "355010000I" || x.value == "355020000I"
          );
        } else if (self.loginInfo.govCode == "A11100000F") {
          self.dropDownList.jobGovCode2s = rData.returnObject.filter(
            (x) => x.value == "A11100000F" || x.value == "A11000600F"
          );
        } else {
          self.dropDownList.jobGovCode2s = rData.returnObject;
        }
      });
    },
    //取得受理申報機關第三層類別
    getSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    //UploadDetailModal 取得受理申報機關第一層類別
    UploadDetailModalGetSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.UploadDetailModal.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //UploadDetailModal 取得受理申報機關第二層類別
    UploadDetailModalGetSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.UploadDetailModal.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //UploadDetailModal 取得受理申報機關第三層類別
    UploadDetailModalGetSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.UploadDetailModal.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //UploadDetailModal 取得受理申報機關第四層類別
    UploadDetailModalGetSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.UploadDetailModal.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    UploadDetailModalGetSyearDropDownList: function () {
      let syears = [""];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //第一頁查詢
    doQuery: function () {
      const self = this;
      //清空
      self.Order = "";
      self.Sort = "";
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        idn: self.form.idn,
        name: self.form.name,
        goV_CODE: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        goV_CODE_STR:
          self.form.govCode1 +
          "," +
          self.form.govCode2 +
          "," +
          self.form.govCode3 +
          "," +
          self.form.govCode4,
        GOVCHECK: parseInt(self.form.govCheck),
        joB_GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        joB_GOV_CODE_STR:
          self.form.jobGovCode1 +
          "," +
          self.form.jobGovCode2 +
          "," +
          self.form.jobGovCode3 +
          "," +
          self.form.jobGovCode4,
        JOBGOVCHECK: parseInt(self.form.jobGovCheck),
        currentpage: self.form.currentpage,
        pagesize: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      //console.log(JSON.stringify(postData));
      B102_SearchGrid(postData).then((rData) => {
        if (rData.result) {
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "NAME";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        idn: self.form.idn,
        name: self.form.name,
        goV_CODE: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        goV_CODE_STR:
          self.form.govCode1 +
          "," +
          self.form.govCode2 +
          "," +
          self.form.govCode3 +
          "," +
          self.form.govCode4,
        GOVCHECK: parseInt(self.form.govCheck),
        joB_GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        joB_GOV_CODE_STR:
          self.form.jobGovCode1 +
          "," +
          self.form.jobGovCode2 +
          "," +
          self.form.jobGovCode3 +
          "," +
          self.form.jobGovCode4,
        JOBGOVCHECK: parseInt(self.form.jobGovCheck),
        currentpage: self.form.currentpage,
        pagesize: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      //console.log(JSON.stringify(postData));
      B102_ReSearchGrid(postData).then((rData) => {
        if (rData.result) {
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    //第一頁重填
    btnClear: function () {
      const self = this;
      self.form = {
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "1",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        idn: "",
        name: "",
        currentpage: 1,
        pagesize: 10,
      };
      self.JobGovCodeInit(self.form);
      self.getSearchJobGovCode1();
      self.GovCodeInit(self.form);
      self.getSearchGovCode1();
    },
    GovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.govCode1 = self.SessionGovCode;
        form.govCode2 = "";
        form.govCode3 = "";
        form.govCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.govCode1 = govCodeArray[0];
          form.govCode2 = govCodeArray[1];
          form.govCode3 = govCodeArray[2];
          form.govCode4 = govCodeArray[3];
        }
      }
    },
    GovCode1Change: function () {
      const self = this;
      self.form.govCode2 = "";
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode2s = [];
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode2Change: function () {
      const self = this;
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode3Change: function () {
      const self = this;
      self.form.govCode4 = "";
      self.dropDownList.govCode4s = [];
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    JobGovCode1Change: function () {
      const self = this;
      self.form.jobGovCode2 = "";
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode2s = [];
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode2Change: function () {
      const self = this;
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode3Change: function () {
      const self = this;
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode4s = [];
    },
    //grid
    //第一頁上傳按鈕
    btnUpload: function (data) {
      const self = this;
      self.UploadModal.show = true;
      self.UploadModal.title = self.pageData.MenuName + "-紙本上傳";
      self.UploadModal.PreData = data;
      self.UploadModal.form.currentpage = 1;
      self.UploadModal.form.pagesize = 10;
      self.B102_SearchGridMain();
    },
    //查詢紙本上傳
    B102_SearchGridMain: function () {
      const self = this;
      if (
        !self.checkPage(
          self.UploadModal.form.currentpage,
          self.UploadModal.form.pagesize
        )
      )
        return;
      let postData = {
        currentpage: self.UploadModal.form.currentpage,
        pagesize: self.UploadModal.form.pagesize,
        idn: self.UploadModal.PreData.idn,
        goV_CODE: self.UploadModal.PreData.goV_CODE,
        pkno: self.UploadModal.PreData.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "上傳",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      B102_SearchGridMain(postData).then((rData) => {
        if (rData.result) {
          self.UploadModal.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    B102_DetailAdd: function (data, index) {
      const self = this;
      let postData = {
        pkno: data.pkno,
        idn: data.idn,
        goV_CODE: data.goV_CODE,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁-編",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      self.UploadDetailModal.grid = {};
      B102_DetailAdd(postData).then((rData) => {
        self.UploadDetailModal.grid = rData.returnObject.gridFamilyDatas;
        const rgrid = self.UploadDetailModal.grid[0];
        self.UploadDetailModal.form = {
          pkno: rgrid.pkno,
          jobGovCode1: rgrid.goV_CODE_STR.split(",")[0],
          jobGovCode2: rgrid.goV_CODE_STR.split(",")[1],
          jobGovCode3: rgrid.goV_CODE_STR.split(",")[2],
          jobGovCode4: rgrid.goV_CODE_STR.split(",")[3],
          idn: rgrid.idn,
          name: rgrid.name,
          sdate: self.$moment(
            parseInt(rgrid.sdate.substr(0, 3)) + 1911 + rgrid.sdate.substr(3, 4)
          )._d,
          syear: rgrid.syear,
          datetime: self.$moment(rgrid.datetime)._d,
          dtype: rgrid.dtype,
          upApplyFlag: rgrid.upApplyFlag == "Y" ? "Y" : "N",
          familyDatas: rgrid.familyDatas,
          file: {
            fileName: rgrid.filE_NAME,
            fileType: rgrid.filE_ALIAS,
            fileString: rgrid.filE_STRING,
          },
        };
        
        // if (
        //   self.UploadDetailModal.form.file.fileName == null ||
        //   self.UploadDetailModal.form.file.fileType == null ||
        //   self.UploadDetailModal.form.file.fileString == null
        // ) {
        //   let opostData = {
        //     seqno: rgrid.seqno,
        //     LogInfo: {
        //       Id: self.loginInfo.id,
        //       PrgCode: self.pageData.PrgName,
        //       ActCd: "下載紙本申報(舊)",
        //       ServiceUnit: self.pageData.ServiceUnit,
        //       Token: self.loginInfo.token,
        //     },
        //   };
        //   UploadReportOld(opostData).then((rData) => {
        //     self.UploadDetailModal.form.file.fileName = rData[0].filE_NAME;
        //     self.UploadDetailModal.form.file.fileType = rData[0].filE_TYPE;
        //     self.UploadDetailModal.form.file.fileString = rData[0].filE_STRING;
        //     // link.download = rData[0].filE_NAME;
        //     // link.href =rData[0].filE_TYPE+","+rData[0].filE_STRING;
        //     // link.click();
        //     if (
        //       self.UploadDetailModal.grid.filE_NAME != null &&
        //       self.UploadDetailModal.grid.filE_ALIAS != null &&
        //       self.UploadDetailModal.grid.filE_STRING != null
        //     ) {
        //       let link = document.getElementById("alink"); // document.createElement("a");
        //       link.innerText = "下載";
        //       link.download = self.UploadDetailModal.grid.filE_NAME;
        //       link.href =
        //         self.UploadDetailModal.grid.filE_ALIAS +
        //         "," +
        //         self.UploadDetailModal.grid.filE_STRING;
        //     }
        //   });
        // }
        // if(grid.familyDatas.length>0){
        //     self.UploadDetailModal.form.familyDatas= grid.familyDatas;
        // }
        // else if (
        //   self.UploadDetailModal.form.file.fileName != null &&
        //   self.UploadDetailModal.form.file.fileType != null &&
        //   self.UploadDetailModal.form.file.fileString != null
        // ) {
        //   let link = document.getElementById("alink"); // document.createElement("a");
        //   link.innerText = "下載";
        //   link.download = self.UploadDetailModal.form.file.fileName;
        //   link.href =
        //     self.UploadDetailModal.form.file.fileType +
        //     "," +
        //     self.UploadDetailModal.form.file.fileString;
        // }

        //link.click();
        self.UploadDetailModal.form.familyDatas.forEach((x) =>
          x.birthdate == ""
            ? (x.birthdate = "")
            : (x.birthdate = self.$moment(
                parseInt(x.birthdate.substr(0, 3)) +
                  1911 +
                  x.birthdate.substr(3, 4)
              )._d)
        );
      });
    },
    UploadDetailModalInit: function () {
      const self = this;
      self.UploadDetailModalGetSearchJobGovCode1();
      self.UploadDetailModalGetSearchJobGovCode2(
        self.UploadDetailModal.form.jobGovCode1
      );
      self.UploadDetailModal.dropDownList.syears =
        self.UploadDetailModalGetSyearDropDownList();
      // if (self.UploadDetailModal.modifyType == "I") {
      //   let postData = {
      //     idn: self.UploadModal.PreData.idn,
      //     goV_CODE: self.UploadModal.PreData.goV_CODE,
      //     LogInfo: {
      //       Id: self.loginInfo.id,
      //       PrgCode: self.pageData.PrgName,
      //       ActCd: "第二頁-新增紙本上傳",
      //       ServiceUnit: self.pageData.ServiceUnit,
      //       Token: self.loginInfo.token,
      //     },
      //   };
      //   B102_DetailFamily(postData).then((rData) => {
      //     self.UploadDetailModal.grid = rData.returnObject.gridFamilyDatas;
      //     if (self.UploadDetailModal.grid.length > 0) {
      //       const grid = self.UploadDetailModal.grid[0];
      //       if (grid.familyDatas.length > 0)
      //         self.UploadDetailModal.form.familyDatas = grid.familyDatas;
      //     }
      //   });
      // }
    },
    //第二頁新增紙本上傳
    UploadModalBtnAdd: function () {
      const self = this;
      self.UploadDetailModal.show = true;
      self.UploadDetailModal.title = self.pageData.MenuName + "-新增";
      self.UploadDetailModal.modifyType = "I";
      self.UploadDetailModalBtnClear();
      //帶第一頁資訊
      self.UploadDetailModal.form.joB_GOV_CODE =
        self.UploadModal.PreData.joB_GOV_CODE;
      self.UploadDetailModal.form.idn = self.UploadModal.PreData.idn;
      self.UploadDetailModal.form.name = self.UploadModal.PreData.name;
      (self.UploadDetailModal.form.jobGovCode1 = self.UploadModal.PreData
        .goV_CODE_STR
        ? self.UploadModal.PreData.goV_CODE_STR.split(",")[0]
        : ""),
        (self.UploadDetailModal.form.jobGovCode2 = self.UploadModal.PreData
          .goV_CODE_STR
          ? self.UploadModal.PreData.goV_CODE_STR.split(",")[1]
          : ""),
        (self.UploadDetailModal.form.jobGovCode3 = self.UploadModal.PreData
          .goV_CODE_STR
          ? self.UploadModal.PreData.goV_CODE_STR.split(",")[2]
          : ""),
        (self.UploadDetailModal.form.jobGovCode4 = self.UploadModal.PreData
          .goV_CODE_STR
          ? self.UploadModal.PreData.goV_CODE_STR.split(",")[3]
          : ""),
        self.UploadDetailModalInit();
    },
    //第二頁編
    UploadModalBtnEdit: function (data, index) {
      const self = this;
      self.UploadDetailModal.show = true;
      self.UploadDetailModal.title = self.pageData.MenuName + "-編輯";
      self.UploadDetailModal.modifyType = "U";
      self.UploadDetailModalBtnClear();
      self.B102_DetailAdd(data, index);
      self.UploadDetailModalInit();
    },
    UploadDetailModalOnFileChange: function (event) {
      const self = this;
      let file = event.target.files[0];
      self.UploadDetailModal.form.uploadFile = file;
    },
    //第三頁新增
    UploadDetailModalBtnAdd: function () {
      const self = this;
      self.FamilyModal.show = true;
      self.FamilyModal.title =
        self.pageData.MenuName + "-配偶及未成年子女-新增";
      self.FamilyModal.modifyType = "I";
      self.FamilyModalBtnClear();
    },
    //第三頁編
    UploadDetailModalBtnEdit: function (index) {
      const self = this;
      self.FamilyModal.show = true;
      self.FamilyModal.title =
        self.pageData.MenuName + "-配偶及未成年子女-編輯";
      self.FamilyModal.modifyType = "U";
      self.FamilyModal.index = index;
      self.FamilyModal.form.title =
        self.UploadDetailModal.form.familyDatas[index].title;
      self.FamilyModal.form.name =
        self.UploadDetailModal.form.familyDatas[index].name;
      self.FamilyModal.form.birthdate =
        self.UploadDetailModal.form.familyDatas[index].birthdate.length == 7
          ? new Date(
              (
                parseInt(
                  self.UploadDetailModal.form.familyDatas[
                    index
                  ].birthdate.substr(0, 3)
                ) + 1911
              ).toString() +
                "/" +
                self.UploadDetailModal.form.familyDatas[index].birthdate.substr(
                  3,
                  2
                ) +
                "/" +
                self.UploadDetailModal.form.familyDatas[index].birthdate.substr(
                  5,
                  5
                )
            )
          : self.UploadDetailModal.form.familyDatas[index].birthdate;
      self.FamilyModal.form.idn =
        self.UploadDetailModal.form.familyDatas[index].idn;
      self.FamilyModal.form.passport =
        self.UploadDetailModal.form.familyDatas[index].passport;
    },
    //第三頁刪除
    UploadDetailModalBtnDelete: function (index) {
      const self = this;
      self.UploadDetailModal.form.familyDatas.splice(index, 1);
    },
    //第二頁明細新增 API
    B102_DetailAddSave: function () {
      const self = this;
      debugger;
      let famDatas = JSON.parse(
        JSON.stringify(self.UploadDetailModal.form.familyDatas)
      );
      famDatas.forEach((x) =>
        x.birthdate.length != 7
          ? self.padLeft(self.$moment(x.birthdate).format("YYYY") - 1911) +
            self.$moment(x.birthdate).format("MMDD")
          : x.birthdate
      );
      let postData = {
        pkno: 0,
        goV_CODE: self.UploadDetailModal.form.jobGovCode4
          ? self.UploadDetailModal.form.jobGovCode4
          : self.UploadDetailModal.form.jobGovCode3
          ? self.UploadDetailModal.form.jobGovCode3
          : self.UploadDetailModal.form.jobGovCode2
          ? self.UploadDetailModal.form.jobGovCode2
          : self.UploadDetailModal.form.jobGovCode1
          ? self.UploadDetailModal.form.jobGovCode1
          : "",
        goV_CODE_STR:
          self.UploadDetailModal.form.jobGovCode1 +
          "," +
          self.UploadDetailModal.form.jobGovCode2 +
          "," +
          self.UploadDetailModal.form.jobGovCode3 +
          "," +
          self.UploadDetailModal.form.jobGovCode4,
        idn: self.UploadDetailModal.form.idn,
        name: self.UploadDetailModal.form.name,
        sdate:
          self.padLeft(
            self.$moment(self.UploadDetailModal.form.sdate).format("YYYY") -
              1911
          ) + self.$moment(self.UploadDetailModal.form.sdate).format("MMDD"),
        syear: self.UploadDetailModal.form.syear,
        dtype: self.UploadDetailModal.form.dtype,
        datetime: self
          .$moment(self.UploadDetailModal.form.datetime)
          .format("YYYYMMDD"),
        upapplyflag: self.UploadDetailModal.form.upApplyFlag,
        fileName: !!self.UploadDetailModal.form.file
          ? self.UploadDetailModal.form.file.fileName
          : null,
        fileType: !!self.UploadDetailModal.form.file
          ? self.UploadDetailModal.form.file.fileType
          : null,
        fileString: !!self.UploadDetailModal.form.file
          ? self.UploadDetailModal.form.file.fileString
          : null,
        userid: self.loginInfo ? self.loginInfo.id : "",
        familyDatas: famDatas,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細新增",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));
      let formData = new FormData();
      if (
        self.UploadDetailModal.form.uploadFile !== "" &&
        self.UploadDetailModal.form.uploadFile !== undefined
      ) {
        formData.append("UPDLOAD_FILE", self.UploadDetailModal.form.uploadFile);
      } else {
        formData.append("UPDLOAD_FILE", null);
      }
      for (var i = 0; i !== famDatas.length; i++) {
        formData.append("familyDatas[" + i + "].IDN", famDatas[i].idn);
        formData.append(
          "familyDatas[" + i + "].PASSPORT",
          famDatas[i].passport
        );
        formData.append("familyDatas[" + i + "].NAME", famDatas[i].name);
        formData.append("familyDatas[" + i + "].TITLE", famDatas[i].title);
        formData.append(
          "familyDatas[" + i + "].BIRTHDATE",
          famDatas[i].birthdate
        );
      }

      formData.append("pkno", 0);
      formData.append(
        "goV_CODE",
        self.UploadDetailModal.form.jobGovCode4
          ? self.UploadDetailModal.form.jobGovCode4
          : self.UploadDetailModal.form.jobGovCode3
          ? self.UploadDetailModal.form.jobGovCode3
          : self.UploadDetailModal.form.jobGovCode2
          ? self.UploadDetailModal.form.jobGovCode2
          : self.UploadDetailModal.form.jobGovCode1
          ? self.UploadDetailModal.form.jobGovCode1
          : ""
      );
      formData.append(
        "goV_CODE_STR",
        self.UploadDetailModal.form.jobGovCode1 +
          "," +
          self.UploadDetailModal.form.jobGovCode2 +
          "," +
          self.UploadDetailModal.form.jobGovCode3 +
          "," +
          self.UploadDetailModal.form.jobGovCode4
      );
      formData.append("idn", self.UploadDetailModal.form.idn);
      formData.append("name", self.UploadDetailModal.form.name);
      formData.append(
        "sdate",
        self.padLeft(
          self.$moment(self.UploadDetailModal.form.sdate).format("YYYY") - 1911
        ) + self.$moment(self.UploadDetailModal.form.sdate).format("MMDD")
      );
      formData.append("syear", self.UploadDetailModal.form.syear);
      formData.append("dtype", self.UploadDetailModal.form.dtype);
      formData.append(
        "datetime",
        self.$moment(self.UploadDetailModal.form.datetime).format("YYYYMMDD")
      );
      formData.append("upapplyflag", self.UploadDetailModal.form.upApplyFlag);

      formData.append("LogInfo.Id", self.loginInfo.id);
      formData.append("LogInfo.PrgCode", self.pageData.PrgName);
      formData.append("LogInfo.Token", self.loginInfo.token);
      formData.append("LogInfo.ActCd", "第二頁明細新增");
      formData.append("LogInfo.ServiceUnit", self.pageData.ServiceUnit);
      B102_DetailAddSave(formData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["新增成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.UploadDetailModal.show = false;
            self.UploadModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          //self.Alert.txt = "新增失敗";
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
        //console.log(rData);
      });
    },
    //第二頁明細修改 API
    B102_DetailEditSave: function () {
      const self = this;
      let famlyDatas = JSON.parse(
        JSON.stringify(self.UploadDetailModal.form.familyDatas)
      );
      debugger;
      famlyDatas.forEach(
        (x) =>
          (x.birthdate =
            self.padLeft(self.$moment(x.birthdate).format("YYYY") - 1911) +
            self.$moment(x.birthdate).format("MMDD"))
      );
      let postData = {
        pkno: self.UploadDetailModal.form.pkno,
        goV_CODE: self.UploadDetailModal.form.jobGovCode4
          ? self.UploadDetailModal.form.jobGovCode4
          : self.UploadDetailModal.form.jobGovCode3
          ? self.UploadDetailModal.form.jobGovCode3
          : self.UploadDetailModal.form.jobGovCode2
          ? self.UploadDetailModal.form.jobGovCode2
          : self.UploadDetailModal.form.jobGovCode1
          ? self.UploadDetailModal.form.jobGovCode1
          : "",
        goV_CODE_STR:
          self.UploadDetailModal.form.jobGovCode1 +
          "," +
          self.UploadDetailModal.form.jobGovCode2 +
          "," +
          self.UploadDetailModal.form.jobGovCode3 +
          "," +
          self.UploadDetailModal.form.jobGovCode4,
        idn: self.UploadDetailModal.form.idn,
        name: self.UploadDetailModal.form.name,
        sdate:
          self.padLeft(
            self.$moment(self.UploadDetailModal.form.sdate).format("YYYY") -
              1911
          ) + self.$moment(self.UploadDetailModal.form.sdate).format("MMDD"),
        syear: self.UploadDetailModal.form.syear,
        dtype: self.UploadDetailModal.form.dtype,
        datetime: self
          .$moment(self.UploadDetailModal.form.datetime)
          .format("YYYYMMDD"),
        upapplyflag: self.UploadDetailModal.form.upApplyFlag,
        fileName: !!self.UploadDetailModal.form.file
          ? self.UploadDetailModal.form.file.fileName
          : null,
        fileType: !!self.UploadDetailModal.form.file
          ? self.UploadDetailModal.form.file.fileType
          : null,
        fileString: !!self.UploadDetailModal.form.file
          ? self.UploadDetailModal.form.file.fileString
          : null,
        userid: self.loginInfo ? self.loginInfo.id : "",
        familyDatas: famlyDatas,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細修改",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      let formData = new FormData();
      if (
        self.UploadDetailModal.form.uploadFile !== "" &&
        self.UploadDetailModal.form.uploadFile !== undefined
      ) {
        formData.append("UPDLOAD_FILE", self.UploadDetailModal.form.uploadFile);
      } else {
        formData.append("UPDLOAD_FILE", null);
      }
      for (var i = 0; i !== famlyDatas.length; i++) {
        formData.append("familyDatas[" + i + "].IDN", famlyDatas[i].idn);
        formData.append(
          "familyDatas[" + i + "].PASSPORT",
          famlyDatas[i].passport
        );
        formData.append("familyDatas[" + i + "].NAME", famlyDatas[i].name);
        formData.append("familyDatas[" + i + "].TITLE", famlyDatas[i].title);
        formData.append(
          "familyDatas[" + i + "].BIRTHDATE",
          famlyDatas[i].birthdate
        );
      }
      //formData.append("familyDatas2", famlyDatas);
      //formData.append("familyDatas[]", famlyDatas);
      formData.append("pkno", self.UploadDetailModal.form.pkno);
      formData.append(
        "goV_CODE",
        self.UploadDetailModal.form.jobGovCode4
          ? self.UploadDetailModal.form.jobGovCode4
          : self.UploadDetailModal.form.jobGovCode3
          ? self.UploadDetailModal.form.jobGovCode3
          : self.UploadDetailModal.form.jobGovCode2
          ? self.UploadDetailModal.form.jobGovCode2
          : self.UploadDetailModal.form.jobGovCode1
          ? self.UploadDetailModal.form.jobGovCode1
          : ""
      );
      formData.append(
        "goV_CODE_STR",
        self.UploadDetailModal.form.jobGovCode1 +
          "," +
          self.UploadDetailModal.form.jobGovCode2 +
          "," +
          self.UploadDetailModal.form.jobGovCode3 +
          "," +
          self.UploadDetailModal.form.jobGovCode4
      );
      formData.append("idn", self.UploadDetailModal.form.idn);
      formData.append("name", self.UploadDetailModal.form.name);
      formData.append(
        "sdate",
        self.padLeft(
          self.$moment(self.UploadDetailModal.form.sdate).format("YYYY") - 1911
        ) + self.$moment(self.UploadDetailModal.form.sdate).format("MMDD")
      );
      formData.append("syear", self.UploadDetailModal.form.syear);
      formData.append("dtype", self.UploadDetailModal.form.dtype);
      formData.append(
        "datetime",
        self.$moment(self.UploadDetailModal.form.datetime).format("YYYYMMDD")
      );
      formData.append("upapplyflag", self.UploadDetailModal.form.upApplyFlag);
      formData.append("LogInfo.Id", self.loginInfo.id);
      formData.append("LogInfo.PrgCode", self.pageData.PrgName);
      formData.append("LogInfo.Token", self.loginInfo.token);
      formData.append("LogInfo.ActCd", "第二頁明細修改");
      formData.append("LogInfo.ServiceUnit", self.pageData.ServiceUnit);
      console.log(JSON.stringify(postData));
      B102_DetailEditSave(formData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["修改成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.UploadDetailModal.show = false;
            self.UploadModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          //self.Alert.txt = "修改失敗";
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁瀏覽申報表 紙本上傳
    DetailUploadPrint: function (data) {
      const self = this;
      let postData = {
        seqno: data.seqno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "瀏覽申報表(紙本申報)",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      // console.log(JSON.stringify(postData));
      B101_UploadReport(postData).then((rData) => {
        if (rData.length > 0) {
          let link = document.createElement("a");
          // link.download = "B101紙本申報";
          // link.href =
          //   "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
          //   rData;
          // link.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + rData;
          link.download = rData[0].filE_NAME;
          link.href =
            "data:" + rData[0].filE_TYPE + ";base64," + rData[0].filE_STRING;
          //link.href = rData[0].filE_TYPE + "," + rData[0].filE_STRING;
          link.click();
        } else {
          UploadReportOld(postData).then((rData) => {
            let link = document.createElement("a");
            link.download = rData[0].filE_NAME;
            link.href = rData[0].filE_TYPE + "," + rData[0].filE_STRING;
            link.click();
          });
          // self.Alert.show = true;
          // self.Alert.title = "錯誤";
          // self.Alert.txt = "未取得資料表";
          // self.Alert.txt = rData.messages;
          // self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第三頁存檔
    UploadDetailModalBtnSave: function () {
      const self = this;
      let errorMsg = [];
      if (self.UploadDetailModal.form.idn.trim() == "") {
        errorMsg.push("請填寫身分證統一編號");
      } else if (!ChkIDorRCNumber(self.UploadDetailModal.form.idn)) {
        errorMsg.push("身分證統一編號格式不對");
      }
      if (self.UploadDetailModal.form.jobGovCode1 == "") {
        errorMsg.push("請填寫服務機關");
      }
      if (self.UploadDetailModal.form.name.trim() == "") {
        errorMsg.push("請填寫姓名");
      }
      if (self.UploadDetailModal.form.sdate == "") {
        errorMsg.push("請填寫申報日期");
      } else if (
        new Date(self.UploadDetailModal.form.sdate) > new Date(Date.now())
      ) {
        errorMsg.push("申報日期不可大於今天");
      } else if (self.UploadDetailModal.form.syear != "") {
        if (
          new Date(self.UploadDetailModal.form.sdate).getFullYear() - 1911 !=
          parseInt(self.UploadDetailModal.form.syear)
        ) {
          errorMsg.push("申報日期與申報年度不符");
        }
      }
      if (self.UploadDetailModal.form.syear == "") {
        errorMsg.push("請填寫申報年度");
      }
      if (self.UploadDetailModal.form.datetime == "") {
        errorMsg.push("請填寫上傳(即交件日)");
      } else if (
        new Date(self.UploadDetailModal.form.datetime) > new Date(Date.now())
      ) {
        errorMsg.push("上傳(即交件日)不可大於今天");
      } else if (
        new Date(self.UploadDetailModal.form.sdate) >
        new Date(self.UploadDetailModal.form.datetime)
      ) {
        errorMsg.push("申報日期不可大於上傳(即交件日)");
      }
      if (self.UploadDetailModal.form.dtype == "") {
        errorMsg.push("請填寫申報種類");
      }
      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }
      if (self.UploadDetailModal.modifyType == "I") {
        self.B102_DetailAddSave();
      } else if (self.UploadDetailModal.modifyType == "U") {
        self.B102_DetailEditSave();
      }
    },
    //第三頁重填
    UploadDetailModalBtnClear: function () {
      const self = this;
      self.UploadDetailModal.form = {
        jobGovCode1: self.UploadDetailModal.form.jobGovCode1,
        jobGovCode2: self.UploadDetailModal.form.jobGovCode2,
        jobGovCode3: self.UploadDetailModal.form.jobGovCode3,
        jobGovCode4: self.UploadDetailModal.form.jobGovCode4,
        idn: self.UploadDetailModal.form.idn,
        name: self.UploadDetailModal.form.name,
        sdate: "",
        syear: "",
        datetime: "",
        dtype: "",
        upApplyFlag: "N",
        familyDatas: [],
      };
    },
    //第四頁存檔
    FamilyModalBtnSave: function () {
      const self = this;
      let errorMsg = [];
      if (!self.UploadDetailModal.form.sdate) {
        errorMsg.push("請先在上一層選取申報日期");
      } else {
        if (
        self.FamilyModal.form.idn.trim() == "" &&
        self.FamilyModal.form.passport.trim() == ""
      ) {
        errorMsg.push("請填寫身分證統一編號或居留證號");
      } else if (
        !ChkIdNo(self.FamilyModal.form.idn) ||
        !isLiveID(self.FamilyModal.form.passport)
      ) {
        errorMsg.push("身分證統一編號/居留證號格式不對");
      } else if (
        self.FamilyModal.form.idn.trim() != "" &&
        self.FamilyModal.form.passport.trim() != ""
      ) {
        errorMsg.push("身分證統一編號/居留證號不可同時有資料");
      } else if (self.FamilyModal.modifyType == "I") {
        var familybool = false;
        self.UploadDetailModal.form.familyDatas.forEach((x) => {
          if (x.idn == self.FamilyModal.form.idn) {
            familybool = true;
          }
        });
        if (familybool) {
          errorMsg.push("已有身分證統一編號資料，不可新增!");
        }
      } else if (self.FamilyModal.modifyType == "U") {
        var familybool = false;
        var resultfamilydata = [];
        var i = 0;
        self.UploadDetailModal.form.familyDatas.forEach((x) => {
          resultfamilydata.push(x);
        });
        //先修改暫存看看
        resultfamilydata.splice(self.FamilyModal.index, 1, {
          title: self.FamilyModal.form.title,
          name: self.FamilyModal.form.name,
          birthdate: self.FamilyModal.form.birthdate,
          idn: self.FamilyModal.form.idn,
          passport: self.FamilyModal.form.passport,
        });
        resultfamilydata.forEach((x) => {
          if (x.idn == self.FamilyModal.form.idn) {
            i = i + 1;
          }
          if (i >= 2) familybool = true;
        });
        if (familybool) {
          errorMsg.push("已有身分證統一編號資料，不可修改!");
        }
      }
      if (self.FamilyModal.form.title == "") {
        errorMsg.push("請填寫稱謂");
      }
      if (self.FamilyModal.form.name.trim() == "") {
        errorMsg.push("請填寫姓名");
      }
      if (self.FamilyModal.form.birthdate == "") {
        errorMsg.push("請填寫生日");
      } else if (
        self.FamilyModal.form.title == "1" &&
        new Date(self.FamilyModal.form.birthdate).getFullYear() >
          new Date(Date.now()).getFullYear() - 18
      ) {
        errorMsg.push("生日錯誤(生日之人尚未成年)");
      } else if (self.FamilyModal.form.title != "1") {
        var dateNow = self.UploadDetailModal.form.sdate;
        if (parseInt(self.UploadDetailModal.form.syear) > 111) {
          if (
            new Date(self.FamilyModal.form.birthdate) <=
            new Date(
              dateNow.getFullYear() - 18,
              dateNow.getMonth(),
              dateNow.getDate()
            )
          ) {
            errorMsg.push("生日錯誤(生日之人已成年)");
          }
        } else {
          if (
            new Date(self.FamilyModal.form.birthdate) <=
            new Date(
              dateNow.getFullYear() - 20,
              dateNow.getMonth(),
              dateNow.getDate()
            )
          ) {
            errorMsg.push("生日錯誤(生日之人已成年)");
          }
        }
      } else if (
        new Date(self.FamilyModal.form.birthdate) > new Date(Date.now())
      ) {
        errorMsg.push("生日不可大於今天");
      }
      if (
        self.UploadDetailModal.form.familyDatas.length > 0 &&
        self.FamilyModal.modifyType == "I"
      ) {
        var familybool = false;
        self.UploadDetailModal.form.familyDatas.forEach((x) => {
          if (x.title == "1" && self.FamilyModal.form.title == "1") {
            familybool = true;
          }
        });
        if (familybool) {
          errorMsg.push("已有配偶資料，不可新增!");
        }
      }
      if (
        self.UploadDetailModal.form.familyDatas.length > 0 &&
        self.FamilyModal.modifyType == "U"
      ) {
        var familybool = false;
        var resultfamilydata = [];
        var i = 0;
        self.UploadDetailModal.form.familyDatas.forEach((x) => {
          resultfamilydata.push(x);
        });
        //先修改暫存看看
        resultfamilydata.splice(self.FamilyModal.index, 1, {
          title: self.FamilyModal.form.title,
          name: self.FamilyModal.form.name,
          birthdate: self.FamilyModal.form.birthdate,
          idn: self.FamilyModal.form.idn,
          passport: self.FamilyModal.form.passport,
        });
        resultfamilydata.forEach((x) => {
          if (x.title == "1") {
            i = i + 1;
          }
          if (i >= 2) familybool = true;
        });
        if (familybool) {
          errorMsg.push("已有配偶資料，不可修改!");
        }
      }
      }
      
      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }

      if (self.FamilyModal.modifyType == "I") {
        self.UploadDetailModal.form.familyDatas.push({
          title: self.FamilyModal.form.title,
          name: self.FamilyModal.form.name,
          birthdate: self.FamilyModal.form.birthdate, //self.padLeft(self.$moment(self.FamilyModal.form.birthdate).format('YYYY') - 1911)  +  self.$moment(self.FamilyModal.form.birthdate).format('MMDD'),
          idn: self.FamilyModal.form.idn,
          passport: self.FamilyModal.form.passport,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第四頁存檔",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        });
        self.FamilyModal.show = false;
        self.FamilyModalBtnClear();
      } else if (self.FamilyModal.modifyType == "U") {
        self.UploadDetailModal.form.familyDatas.splice(
          self.FamilyModal.index,
          1,
          {
            title: self.FamilyModal.form.title,
            name: self.FamilyModal.form.name,
            birthdate: self.FamilyModal.form.birthdate, //self.padLeft(self.$moment(self.FamilyModal.form.birthdate).format('YYYY') - 1911)  +  self.$moment(self.FamilyModal.form.birthdate).format('MMDD'),
            idn: self.FamilyModal.form.idn,
            passport: self.FamilyModal.form.passport,
          }
        );
        self.FamilyModal.show = false;
        self.FamilyModalBtnClear();
      }
    },
    //第四頁重填
    FamilyModalBtnClear: function () {
      const self = this;
      self.FamilyModal.form = {
        title: "2",
        name: "",
        birthdate: "",
        idn: "",
        passport: "",
      };
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    UploadDetailModalGovCode1Change: function () {
      const self = this;
      self.UploadDetailModal.form.jobGovCode2 = "";
      self.UploadDetailModal.form.jobGovCode3 = "";
      self.UploadDetailModal.form.jobGovCode4 = "";
      self.UploadDetailModal.dropDownList.jobGovCode2s = [];
      self.UploadDetailModal.dropDownList.jobGovCode3s = [];
      self.UploadDetailModal.dropDownList.jobGovCode4s = [];
    },
    UploadDetailModalGovCode2Change: function () {
      const self = this;
      self.UploadDetailModal.form.jobGovCode3 = "";
      self.UploadDetailModal.form.jobGovCode4 = "";
      self.UploadDetailModal.dropDownList.jobGovCode3s = [];
      self.UploadDetailModal.dropDownList.jobGovCode4s = [];
    },
    UploadDetailModalJobGovCode3Change: function () {
      const self = this;
      self.UploadDetailModal.form.jobGovCode4 = "";
      self.UploadDetailModal.dropDownList.jobGovCode4s = [];
    },
  },
  watch: {
    "form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode2(newValue);
    },
    "form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode3(newValue);
    },
    "form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode4(newValue);
    },
    "form.govCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode2(newValue);
    },
    "form.govCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode3(newValue);
    },
    "form.govCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode4(newValue);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "UploadModal.form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.B102_SearchGridMain();
      }
    },
    "UploadModal.form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.B102_SearchGridMain();
      }
    },
    "UploadDetailModal.form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.UploadDetailModalGetSearchJobGovCode2(newValue);
    },
    "UploadDetailModal.form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.UploadDetailModalGetSearchJobGovCode3(newValue);
    },
    "UploadDetailModal.form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.UploadDetailModalGetSearchJobGovCode4(newValue);
    },
    "UploadDetailModal.form.idn": function (newValue, oldValue) {
      const self = this;
      if (newValue != oldValue) {
        self.UploadDetailModal.form.idn = newValue.toUpperCase();
      }
    },
    "FamilyModal.form.idn": function (newValue, oldValue) {
      const self = this;
      if (newValue != oldValue) {
        self.FamilyModal.form.idn = newValue.toUpperCase();
      }
    },
  },
  created() {
    const self = this;
    const Menu = getMenu(self.pageData.PrgName);
    //RoleAuthorizeMenu
    if (Menu) {
      self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.GovCodeInit(self.form);
    self.JobGovCodeInit(self.form);
    self.getSearchGovCode1();
    self.getSearchJobGovCode1();
    //this.doQuery();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
